import { _types } from './constant'
import api from '@/api'

const state = {
    loadingSettings: null
};

const getters = {
    [_types.getters.GET_ALL_SETTINGS](state){
        return state.loadingSettings
    }
};

const actions = {
    async [_types.actions.GET_ALL_SETTINGS]({commit}, payload){
        try {
            let res = await api.getLoadingSettings();
            let { status = false, data = null } = res.data
            if( status ){
                commit(_types.mutations.SET_ALL_SETTINGS, data )
            }
            return res
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.SAVE_ALL_SETTINGS]({}, payload){
        try {
            return await api.saveAllSettings(payload);
        } catch (error) {
            throw error;
        }
    }
};

const mutations = {
    [_types.mutations.SET_ALL_SETTINGS](state , payload = null ){
        if ( payload.settings ) {
            payload.settings.active = payload.settings.active ? true : false
        }
        state.loadingSettings = payload
    }
};
export default {
    state,
    actions,
    mutations,
    getters,
    namespaced: true,
};